var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationTeamWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 260,
    viewBox: "0 0 364 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_273_309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.151 164.391L254.413 130.329L291.703 142.878L279.625 146.555C277.89 147.083 276.314 147.973 275.022 149.153C273.729 150.334 272.755 151.774 272.177 153.358L268.151 164.391ZM292.496 171.391C291.62 171.391 290.909 172.102 290.909 172.978V179.325C290.909 182.831 293.751 185.672 297.256 185.672H347.24C350.745 185.672 353.587 182.831 353.587 179.325V177.739C353.587 174.233 350.745 171.391 347.24 171.391H292.496Z",
    fill: "#0756F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_273_309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4354 135.272L109.174 101.21L71.8843 113.759L83.9621 117.436C85.6966 117.964 87.2726 118.854 88.5653 120.035C89.8581 121.215 90.8321 122.655 91.4102 124.239L95.4354 135.272ZM71.091 139.514C71.9674 139.514 72.6778 140.224 72.6778 141.101V147.448C72.6778 150.953 69.8361 153.795 66.3307 153.795H16.3472C12.8418 153.795 10.0001 150.953 10.0001 147.448V145.861C10.0001 142.356 12.8418 139.514 16.3472 139.514H71.091Z",
    fill: "#FF751D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_273_309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.524 201.947L211.262 167.885L173.973 180.434L186.051 184.111C187.785 184.639 189.361 185.528 190.654 186.709C191.947 187.89 192.921 189.33 193.499 190.914L197.524 201.947ZM173.18 212.506C174.056 212.506 174.767 213.216 174.767 214.093V220.44C174.767 223.945 171.925 226.787 168.42 226.787H118.436C114.931 226.787 112.089 223.945 112.089 220.44V218.853C112.089 215.347 114.931 212.506 118.436 212.506H173.18Z",
    fill: "#01EC51"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_273_309)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 65.2986,
    width: 30.1488,
    height: 30.1489,
    rx: 15.0744,
    fill: "#FFFFEF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.197 82.745L310.964 83.9778V81.4545C310.378 80.6068 310.064 79.6011 310.062 78.5707C310.062 75.5842 312.685 73.1636 315.92 73.1636C318.853 73.1636 321.282 75.1525 321.71 77.7488C322.031 77.6959 322.355 77.6694 322.679 77.6695C325.666 77.6695 328.086 79.8882 328.086 82.6261C328.086 83.6399 327.755 84.5816 327.185 85.3666V87.5826L326.081 86.4786C325.095 87.2024 323.902 87.5894 322.679 87.5826C320.133 87.5826 317.998 85.9695 317.424 83.7976C316.944 83.9148 316.44 83.9778 315.92 83.9778C314.578 83.9853 313.269 83.5522 312.197 82.745ZM315.92 82.1755C318.191 82.1755 319.976 80.5281 319.976 78.5707C319.976 76.6133 318.191 74.966 315.92 74.966C313.649 74.966 311.865 76.6133 311.865 78.5707C311.865 80.5281 313.649 82.1755 315.92 82.1755ZM319.116 83.1037C319.377 84.5969 320.852 85.7802 322.679 85.7802C324.698 85.7802 326.284 84.3383 326.284 82.6261C326.284 80.9138 324.698 79.4719 322.679 79.4719C322.329 79.4719 321.992 79.5151 321.673 79.5963C321.368 81.0616 320.423 82.316 319.116 83.1028V83.1037Z",
    fill: "#0756F1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_273_309)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.614,
    y: 226.787,
    width: 26.9732,
    height: 26.9752,
    rx: 13.4866,
    fill: "#FFFFEF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.649 240.274C333.649 236.711 336.537 233.823 340.1 233.823C343.663 233.823 346.551 236.711 346.551 240.274C346.551 243.837 343.663 246.725 340.1 246.725C336.537 246.725 333.649 243.837 333.649 240.274ZM334.939 240.274C334.939 241.643 335.483 242.956 336.451 243.924C337.419 244.891 338.732 245.435 340.1 245.435C341.469 245.435 342.782 244.891 343.75 243.924C344.717 242.956 345.261 241.643 345.261 240.274C345.261 238.906 344.717 237.593 343.75 236.625C342.782 235.657 341.469 235.113 340.1 235.113C338.732 235.113 337.419 235.657 336.451 236.625C335.483 237.593 334.939 238.906 334.939 240.274ZM337.682 239.273C337.839 238.945 338.097 238.016 338.284 238.016C338.469 238.016 338.402 238.483 338.568 238.524C338.708 238.558 338.6 238.315 338.989 238.272C339.378 238.229 339.802 238.467 339.802 238.467C339.802 238.467 340.262 238.581 340.685 238.467C340.685 238.467 340.462 238.127 340.736 238.016C341.009 237.905 341.382 238.316 341.396 238.581C341.409 238.846 340.787 239.024 340.787 239.024L341.396 239.39C341.396 239.39 341.574 238.823 341.955 238.818C342.294 238.811 342.718 239.431 342.519 239.71C342.321 239.989 342.193 239.797 342.193 239.797C342.193 239.797 341.587 240.411 341.396 240.521C341.205 240.631 340.939 240.521 340.939 240.521C340.939 240.521 340.826 240.73 340.939 240.827C341.168 241.063 341.763 241.297 341.763 241.297C341.763 241.297 343.592 241.595 343.648 241.968C343.705 242.341 342.193 244.226 341.955 244.226H341.39C341.16 243.819 341.763 242.52 341.763 242.52C341.763 242.52 341.453 242.177 341.39 241.968C341.329 241.759 341.51 241.391 341.51 241.391L340.685 241.011C340.685 241.011 340.247 241.011 340.029 240.839C339.812 240.667 339.697 239.71 339.697 239.71L338.91 239.133C338.91 239.133 338.226 240.001 338.004 239.89C337.78 239.78 337.526 239.6 337.682 239.273ZM341.921 237.92C341.376 237.92 340.066 237.227 340.286 236.855C340.286 236.322 341.663 236.402 341.959 236.402C342.254 236.402 342.978 236.631 343.38 236.951C343.782 237.27 343.21 237.727 343.011 237.92C342.811 238.113 342.466 237.92 341.921 237.92Z",
    fill: "#01EC51"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_273_309)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.124,
    y: 9,
    width: 42.0496,
    height: 42.0527,
    rx: 21.0248,
    fill: "#FFFFEF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.152 30.0263L94.0954 40.0832L91.5817 37.5677L99.123 30.0263L91.5817 22.4833L94.0954 19.9695L104.152 30.0263ZM77.1728 30.0263L84.7159 37.5677L82.2021 40.0832L72.1453 30.0263L82.2021 19.9695L84.7159 22.4833L77.1728 30.0263Z",
    fill: "#FF751D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.874 123.329C216.506 123.329 234.043 106.76 234.043 86.3223C234.043 65.8841 216.506 49.3157 194.874 49.3157C173.241 49.3157 155.704 65.8841 155.704 86.3223C155.704 106.76 173.241 123.329 194.874 123.329Z",
    stroke: "white",
    strokeWidth: 6.95032
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.19 32.8123C144.093 36.0437 155.194 43.5409 163.795 54.1571",
    stroke: "white",
    strokeWidth: 6.95032
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.144 66.3516C245.219 58.3892 257.747 53.2785 271.81 51.8014",
    stroke: "white",
    strokeWidth: 6.95032
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.802 153.655C151.169 150.305 148.453 146.398 146.823 142.18C145.193 137.962 144.685 133.524 145.331 129.144C145.976 124.764 147.761 120.536 150.574 116.726C153.386 112.916 157.166 109.605 161.676 107.002",
    stroke: "white",
    strokeWidth: 6.95032
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_273_309",
    x: 244.893,
    y: 120.808,
    width: 118.215,
    height: 74.3851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.76033
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.337255 0 0 0 0 0.945098 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_273_309",
    x: 0.479339,
    y: 91.6891,
    width: 118.215,
    height: 71.6265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.76033
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.458824 0 0 0 0 0.113725 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_273_309",
    x: 102.568,
    y: 158.364,
    width: 118.215,
    height: 77.9437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.76033
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.92549 0 0 0 0 0.317647 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_273_309",
    x: 297.762,
    y: 59.0609,
    width: 42.624,
    height: 42.6243,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.11884
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_273_309",
    x: 321.033,
    y: 221.206,
    width: 38.1345,
    height: 38.1364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.79033
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_273_309",
    x: 58.4241,
    y: 0.300078,
    width: 59.4494,
    height: 59.4526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.34996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_309",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationTeamWork);
export default __webpack_public_path__ + "static/media/Illustration-TeamWork.d20601238ff158f434840dded23c755b.svg";
export { ForwardRef as ReactComponent };